// extracted by mini-css-extract-plugin
export var copyableField = "_nn-4";
export var customerBadge = "_nn-0";
export var customerInfoTitle = "_nn-2";
export var details = "_nn-1";
export var dropdownContainer = "_nn-5";
export var dropdownImage = "_nn-6";
export var editAssigneeForm = "_nn-a";
export var editButton = "_nn-3";
export var email = "_nn-7";
export var hidden = "_nn-d";
export var input = "_nn-8";
export var saveButton = "_nn-b";
export var shopifyIcon = "_nn-c";
export var suggestionBadge = "_nn-e";
export var suggestionText = "_nn-f";
export var username = "_nn-9";